import classNames from 'classnames'
import { DayOfWeekProps } from 'feature/serviceCenters/types'

import style from './ServiceWorkScheduleBlock.module.scss'

type TServiceWorkScheduleBlock = {
  weekdaysStart: string
  weekdaysEnd: string
  saturdayStart: string
  saturdayEnd: string
  sundayStart: string
  sundayEnd: string
}

// график работы по дням неделям
export function ServiceWorkScheduleBlock({
  weekdaysStart,
  weekdaysEnd,
  saturdayStart,
  saturdayEnd,
  sundayStart,
  sundayEnd,
}: TServiceWorkScheduleBlock) {
  const daysOfWeek = ['Пн - пт', 'Суббота', 'Воскресенье']

  const setStartHour = (index: number) => {
    if (index === 1) {
      return saturdayStart
    }

    if (index === 2) {
      return sundayStart
    }

    return weekdaysStart
  }

  const setEndHour = (index: number) => {
    if (index === 1) {
      return saturdayEnd
    }

    if (index === 2) {
      return sundayEnd
    }

    return weekdaysEnd
  }

  const workSchedule = daysOfWeek.map((day, index) => {
    return {
      name: day,
      start: setStartHour(index),
      end: setEndHour(index),
    }
  })
  return (
    <div className={style.scheduleList}>
      {workSchedule.map((item: DayOfWeekProps, index) => {
        const isWeekend =
          item.start === null ||
          item.end === null ||
          (item.start === '00:00' && item.end === '00:00')
        return (
          <div className={style.dayOfWeek} key={index}>
            <span className='default-text'>{item.name}</span>
            <span
              className={classNames('default-text', {
                [style.weekend]: isWeekend,
              })}
            >
              {isWeekend ? 'Выходной' : `${item.start}-${item.end}`}
            </span>
          </div>
        )
      })}
    </div>
  )
}
